import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

export const AdvantageWrapper = styled(BlockContainer)<{ isWide: boolean }>`
    overflow: hidden;

    ${({ isWide }) => isWide && `
        grid-column: span 2;
    `};
`;

export const AdvantageImage = styled.div`
    flex: 0 0;
    flex-basis: 48px;
    height: 48px;

    img,
    picture {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: contain;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-basis: 56px;
        height: 56px;
    }
`;

export const Description = styled(Paragraph4)`
    ${textOverflowLineClamp(4)};
`;
